module.exports = __webpack_public_path__ + "img/item-top.77b8d2f4.png";